import { createContext, useContext, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const t = localStorage.getItem("cp_token");
    return t ? { email: localStorage.getItem("cp_email") } : null;
  });

  const login = async (email, password) => {
    const data = await api.login({ email, password });
    localStorage.setItem("cp_token", data.token);
    localStorage.setItem("cp_email", data.user.email);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("cp_token");
    localStorage.removeItem("cp_email");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
